import { z } from "zod";
import { AccountUserSchema } from "./AccountUser";
import { BaseChangelogSchema } from "./Changelog";

export const DocumentOrderChangelogSchema = BaseChangelogSchema.extend({
  accountUser: AccountUserSchema.nullable(),
});
export const PartialDocumentOrderChangelogSchema =
  DocumentOrderChangelogSchema.deepPartial();

export type PartialDocumentOrderChangelog = z.infer<
  typeof PartialDocumentOrderChangelogSchema
>;

export type DocumentOrderChangelog = z.infer<
  typeof DocumentOrderChangelogSchema
>;
